import { getStorage, setStorage } from './storage';

export let setOrder = order => {
  setStorage('order', order);
};

export let getOrder = () => {
  return getStorage('order');
};

export let setProducts = products => {
  setStorage('products', products);
};

export let getProducts = () => {
  return getStorage('products') ?? [];
};

export let setPrograms = programs => {
  setStorage('programs', programs);
};

export let getPrograms = () => {
  return getStorage('programs') ?? [];
};

export let setIndex = index => {
  setStorage('index', index);
};

export let getIndex = () => {
  return getStorage('index');
};
